import { useState } from 'react';
import { translations } from './i18n';
import { useScrolled } from './hooks';

import Navbar       from './components/Navbar';
import ProductStrip from './components/ProductStrip';
import Ticker       from './components/Ticker';
import Hero         from './components/Hero';
import HowItWorks   from './components/HowItWorks';
import Products     from './components/Products';
import Tokenomics   from './components/Tokenomics';
import Chart        from './components/Chart';
import Ecosystem    from './components/Ecosystem';
import Roadmap      from './components/Roadmap';
import Community    from './components/Community';
import CTA          from './components/CTA';
import Footer       from './components/Footer';
import Analytics    from './components/Analytics';

export default function App() {
  const [lang, setLang] = useState('en');
  const scrolled = useScrolled(40);
  const t = translations[lang];

  return (
    <div style={{ background: '#050509', color: '#fff', minHeight: '100vh' }}>
      <Analytics />
      <Navbar
        scrolled={scrolled}
        t={t.nav}
        lang={lang}
        setLang={setLang}
      />

      <div style={{ paddingTop: 64, position: 'relative', zIndex: 1 }}>
        <ProductStrip />
        <Ticker />
        <Hero        t={t.hero}       />
        <HowItWorks  t={t.how}        />
        <Products    t={t.products}   />
        <Tokenomics  t={t.tokenomics} />
        <Chart       t={t.chart}      />
        <Ecosystem   t={t.ecosystem}  />
        <Roadmap     t={t.roadmap}    />
        <Community   t={t.community}  />
        <CTA         t={t.cta}        />
        <Footer      t={t.footer}     />
      </div>
    </div>
  );
}
